import React, { useEffect, useRef } from 'react';

interface FaviconGeneratorProps {
  size?: number;
}

export const FaviconGenerator: React.FC<FaviconGeneratorProps> = ({ size = 32 }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const generateFavicon = () => {
      const canvas = canvasRef.current;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      // Set canvas size
      canvas.width = size;
      canvas.height = size;

      // Create gradient
      const gradient = ctx.createLinearGradient(0, 0, size, size);
      gradient.addColorStop(0, '#3B82F6');
      gradient.addColorStop(1, '#1D4ED8');

      // Draw speech bubble shape
      ctx.fillStyle = gradient;
      ctx.beginPath();
      
      // Main bubble
      const bubbleSize = size * 0.8;
      const x = (size - bubbleSize) / 2;
      const y = (size - bubbleSize) / 2;
      const radius = bubbleSize * 0.2;
      
      ctx.roundRect(x, y, bubbleSize, bubbleSize * 0.7, radius);
      ctx.fill();

      // Tail
      ctx.beginPath();
      ctx.moveTo(x + bubbleSize * 0.3, y + bubbleSize * 0.7);
      ctx.lineTo(x + bubbleSize * 0.2, y + bubbleSize * 0.9);
      ctx.lineTo(x + bubbleSize * 0.5, y + bubbleSize * 0.7);
      ctx.fill();

      // Add dots
      ctx.fillStyle = 'white';
      const dotRadius = size * 0.04;
      const dotY = y + bubbleSize * 0.35;
      
      ctx.beginPath();
      ctx.arc(x + bubbleSize * 0.25, dotY, dotRadius, 0, Math.PI * 2);
      ctx.fill();
      
      ctx.beginPath();
      ctx.arc(x + bubbleSize * 0.5, dotY, dotRadius, 0, Math.PI * 2);
      ctx.fill();
      
      ctx.beginPath();
      ctx.arc(x + bubbleSize * 0.75, dotY, dotRadius, 0, Math.PI * 2);
      ctx.fill();

      // Convert to favicon
      const dataURL = canvas.toDataURL('image/png');
      
      // Update favicon
      let favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
      if (!favicon) {
        favicon = document.createElement('link');
        favicon.rel = 'icon';
        document.head.appendChild(favicon);
      }
      favicon.href = dataURL;
    };

    generateFavicon();
  }, [size]);

  return <canvas ref={canvasRef} style={{ display: 'none' }} />;
};

export default FaviconGenerator; 